//from Access2Global FeatureSwitches
export const FEATURE_SWITCHES = {
	PARTS_PHYSICAL_INVENTORY: 1,
	REPAIR_ORDER_VIS_BUTTON_VISIBILITY: 2,
	FLEX_BUY_LOAN_TYPE: 3,
	KIA_V_4_4: 4,
	ADVANCED_PAID_LEAVE: 5,
	SALES_PROPOSALS: 6,
	PARTS_INVOICE_TO_OEM: 7,
	TOYOTA_BODY_SHOP_RO_V_5_12_4: 8,
	TOYOTA_VIAI_VERSION_5_10: 9,
	TOYOTA_OAUTH_2: 10,
	TOPAZ_INTEGRATION: 11,
	BALLOON_LOAN_TYPE: 12,
	E_LEADS_CONFLICTS: 13,
	STELLANTIS_SEND_AS_VUE: 14,
	GM_OP_CODE: 15,
	CUSTOMER_MERGE: 16,
	TOYOTA_VEHICLE_INVENTORY_PRICE_CHECK: 17,
	VUE_LIMELIGHT_HEADER: 18,
	UDB_FORD_5_1: 19,
	MESSAGE_QUEUE: 20,
	PRO_PARTS_NET: 21,
	SERVICE_ESTIMATE: 22,
	CUSTOMER_DEAL_LIFECYCLE: 23,
	DEALER_CONNECT: 24,
	FORD_RIM: 25,
	FORD_UDB_5_1_PARTS_INVENTORY: 26,
	FORD_UDB_5_1_OTC: 27,
	FORD_UDB_5_1_REPAIR_ORDER: 28,
	FORD_UDB_5_1_SERVICE_APPOINTMENTS: 29,
	FORD_UDB_5_1_USED_VEHICLE_SALES: 30,
	CUSTOMER_FIND_DUPLICATES: 31,
	CUSTOMER_MERGE_EMBEDDED: 32,
	PARTS_LABELS: 33,
	REPORT_GENERATOR: 34,
	LIMELIGHT_AP_PAYMENT_PROCESSING: 35,
	IMPORT_POSTING: 36,
	SET_INTERFACES: 37,
	VIN_SOLUTIONS_CONFLICTS: 38,
	INTERCO_JOURNAL: 39,
	FORD_UDB_COMMENTS: 40,
	VUE_LOGIN: 42,
	FORD_UDB_5_2_PARTS_INVENTORY_UPDATES: 43,
	FORD_UDB_5_2_OTC_UPDATES: 44,
	FORD_UDB_5_2_REPAIR_ORDER_UPDATES: 45,
	FORD_UDB_5_2_SERVICE_APPOINTMENT_UPDATES: 46,
	FORD_UDB_5_2_USED_VEHICLE_SALES: 47,
	FORD_UDB_51_AUDIT_FILES_REPAIR_ORDER: 48,
	COMPANY_LOCATIONS: 51,
	COMPANY_LOCATIONS_SERVICE: 52,
	COMPANY_LOCATIONS_PARTS: 53,
	ALVIN: 54,
	ROUTE_SHEET_SIGNAL_R_ENABLED: 55,
	PARTS_DESK_V_2: 56,
	FORD_DCDS_OWS: 57,
	FORD_DCDS_WEB_GOASIS: 58,
	FORD_DCDS_FINANCIAL: 59,
	FORD_DCDS_REPORTS: 60,
	FORD_DCDS_PARTS: 61,
	GM_SAI_V_1_17: 62,
	DCS_USER_SETTINGS: 63,
	CROSS_COMPANY_CUSTOMER_MERGE: 64,
	MAZDA_FINANCIAL: 65,
	CALCULATED_TLR_BY_LOCATION: 66,
	REPORT_GENERATOR_SCHEDULED_REPORTS: 67,
	HONDA_FLAT_RATE: 68,
	SUB_LOCATION_PARTS_SERVICE: 69,
	CUSTOM_BUYERS_GUIDE: 70,
	EXCEL_EXPORT: 71,
	// MY_GM_REWARDS: 72, //remove dupe
	STELLANTIS_REPAIR_ORDER: 73,
	STELLANTIS_SERVICE_APPOINTMENT: 74,
	STELLANTIS_PARTS_INVENTORY: 75,
	STELLANTIS_PARTS_INVOICE: 76,
	NEXT_CUSTOMER_NUMBER: 77,
	VUE_CORE_VERSION: 78,
	CREDIT_APPLICATION_UI: 79,
	GM_REWARDS: 86,
	USE_PAYMENT_METHODS: 104,
	AI_POWERED_INTERFACE: 108,
	SERVICE_LABOR_RATE_IMPROVEMENTS: 114,
	POSTHOG: 127
};
